// FIXME Add remaining theme values
var THEME = {
    colors: {
        blue: "#445a82",
        gray: "#212322",
        grayLight: "#5a5a5a",
        grayAccent: "#88888d",
    },
};
export default THEME;
